import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import config from "../../../config";
import "./Mission.css";
import { PulseLoader } from "react-spinners";
import { SUPPORT_EMAIL, MISSION_STATUS } from "./Constants/missionConstants";

// Components
import MissionHeader from "./Components/MissionHeader/MissionHeader";
import McqInterface from "./Components/McqInterface/McqInterface";
import FileUploadInterface from "./Components/FileUploadInterface/FileUploadInterface";
import PreviousSubmissions from "./Components/PreviousSubmissions/PreviousSubmissions";
import MissionStatusScreen from "./Components/MissionStatusScreen/MissionStatusScreen";

function Mission({
  id,
  contextData,
  mission,
  timeLeftToStart,
  timeLeft,
  loading,
  handleMcqAnswerChange,
  handleMcqReview,
  handleMcqSubmit,
  handleUpload,
  mcqAnswers,
  mcqSubmitting,
  mcqSubmitStatus,
  mcqReviewData,
  selectedFile,
  uploadStatus,
  uploading,
  uploadProgress,
  fileInputRef,
  setSelectedFile,
  setUploadStatus,
  setUploadProgress,
}) {
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setUploadStatus("");
    setUploadProgress(0);
    if (e.target.files[0]) {
      handleUpload(e.target.files[0]);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  // Loading State
  if (loading) {
    return (
      <div className="loadingBox">
        <PulseLoader color={config.PRIMARY_COLOR} />
      </div>
    );
  }

  // Can Submit State
  if (mission?.missionSubmissionStatus?.canSubmit) {
    return (
      <Box
        sx={{
          minHeight: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          py: 5,
          px: 6,
        }}
      >
        <MissionHeader mission={mission} />

        {mission?.task?.type === "mcq" ? (
          <McqInterface
            mission={mission}
            timeLeft={timeLeft}
            mcqAnswers={mcqAnswers}
            mcqSubmitting={mcqSubmitting}
            mcqSubmitStatus={mcqSubmitStatus}
            mcqReviewData={mcqReviewData}
            handleMcqAnswerChange={handleMcqAnswerChange}
            handleMcqReview={handleMcqReview}
            handleMcqSubmit={handleMcqSubmit}
            contextData={contextData}
            missionId={id}
          />
        ) : (
          <FileUploadInterface
            mission={mission}
            timeLeft={timeLeft}
            selectedFile={selectedFile}
            uploadStatus={uploadStatus}
            uploading={uploading}
            uploadProgress={uploadProgress}
            fileInputRef={fileInputRef}
            handleFileChange={handleFileChange}
            handleButtonClick={handleButtonClick}
          />
        )}

        <PreviousSubmissions mission={mission} />

        <Divider
          sx={{
            my: 6,
            width: "100%",
            maxWidth: 900,
            mx: "auto",
            borderColor: "#b3b3b340",
          }}
        />
        <Typography
          sx={{
            color: "#888",
            fontSize: 15,
            textAlign: "center",
            mt: 2,
          }}
        >
          For any technical issues, contact{" "}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            style={{
              color: config.PRIMARY_COLOR,
              textDecoration: "underline",
            }}
          >
            {SUPPORT_EMAIL}
          </a>
        </Typography>
      </Box>
    );
  }

  // Status Screens
  const statusReason = mission?.missionSubmissionStatus?.canNotSubmitReason;

  if (statusReason === MISSION_STATUS.NOT_STARTED) {
    return (
      <MissionStatusScreen
        status={MISSION_STATUS.NOT_STARTED}
        missionName={mission?.name}
        timeLeftToStart={timeLeftToStart}
        contextData={contextData}
        id={id}
      />
    );
  }

  if (statusReason === MISSION_STATUS.ENDED) {
    return (
      <MissionStatusScreen
        status={MISSION_STATUS.ENDED}
        missionName={mission?.name}
      />
    );
  }

  if (statusReason === MISSION_STATUS.PAUSED) {
    return (
      <MissionStatusScreen
        status={MISSION_STATUS.PAUSED}
        missionName={mission?.name}
      />
    );
  }

  // Default Status Screen
  return <MissionStatusScreen status="default" missionName={mission?.name} />;
}

export default Mission;
